import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService, User } from '../auth-service/auth.service';
import { Router } from '@angular/router';
import { Config } from '../../shared/otpconfig';
@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css'],
})
export class AuthComponent implements OnInit {
  loginForm: FormGroup;
  errorMessage = null;
  userRes: User;
  islogin: boolean;
  emailForm:FormGroup;
  verifyEmail:boolean = false;
  emailSend:boolean = false;
  passForm:FormGroup;
  confirmPassFrom:FormGroup;
  verifyPass:boolean = false;
  showStatus:boolean = false;
  isLoading:boolean = false;
  timeLeft: number = 60;
  patient:any;
  interval:any;
  count:number=1;
  showResendFlag:boolean=false;
  otpForm:FormGroup;
  istrue:boolean=false;
  recievenumber:any;
  isTrue:boolean = true;
  phoneNo:any;
  id:any;
  token:any;
  emailTime:boolean =true;
  otpTime:boolean =false;
  passTime:boolean =false;

  @ViewChild ('closeforgetPass',{static:false}) clsref:any;
  @ViewChild ('ngOtpInput',{static:false}) otpinput:any;
  config :Config = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: ''
  };
  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit() {
    this.onInitform();
    this.myFunction();
  }
  onClickLogin() {
    const email = this.loginForm.value['email'];
    const password = this.loginForm.value['password'];
    this.authService.loginhm(email, password).subscribe(
      (res) => {
        this.userRes = res;
        this.islogin = !!this.userRes;
        this.router.navigate(['/pas/dashboard']);
      },
      (error) => {
        console.log(error);
        this.errorMessage = error;
      }
    );
  }

  onInitform() {
    this.emailForm = new FormGroup ({
      email: new FormControl(null,[Validators.required])
    })
    this.loginForm = new FormGroup({
      email: new FormControl(null, [Validators.required]),
      password: new FormControl(null, [Validators.required]),
    });
    this.passForm =  new FormGroup ({
      pass: new FormControl(null,[Validators.required])
    });
    this.confirmPassFrom = new FormGroup ({
      confirmPass: new FormControl(null,[Validators.required])
    });
    this.otpForm =  new FormGroup ({
      otp: new FormControl(null,[Validators.required])
    })
  }
  submitEmail() {
    this.isLoading = true;
    this.authService.otpmail(this.emailForm.value.email).subscribe((res:any)=>{
      this.emailTime = false;
      console.log("this is response",res);
      this.phoneNo = res.response.phoneNo
      this.otpTime = true;
      this.isLoading = false;
      this.startTimer();
    },(error)=>{
      this.isLoading = false;
    })
  }
  checker(){
    if(this.passForm.value.pass == this.confirmPassFrom.value.confirmPass){
      this.verifyPass = true;
    }else{
      this.verifyPass = false;
    }
  }
  notVerify(){
    if(this.passForm.value.pass == this.confirmPassFrom.value.confirmPass){
      this.showStatus = false;
    }
    else{
      this.showStatus = true;
    }
  }
  submitPass(){
    this.isLoading = true;
    this.authService.changePass(this.passForm.value.pass,this.phoneNo,this.id,this.token).subscribe((res:any)=>{
      this.isLoading = false;
      this.closefrg();
      alert("Successfully Updated Password")
    },(error)=>{
      this.isLoading = false;
    })
  }
  submitOtp(){
    this.isLoading = true;
    this.authService.otplogin(this.otpForm.value.otp,this.phoneNo).subscribe((res:any)=>{
      this.token = res.response.token;
      this.id =  res.response.userData.id;
      this.otpTime = false;
      this.passTime = true;
      this.isLoading = false;
      console.log("this is login data",res);
      
    },(error)=>{
      this.isLoading=false;
    })
  }
  startTimer() {
    this.timeLeft=60;
    // this.resetOTP();
    if(this.otpinput != undefined){
    this.otpinput.setValue('');
    }
    this.showResendFlag=false;
    this.isTrue = true;
    this.interval = setInterval(() => {
      if(this.timeLeft > 0) {
        this.timeLeft--;
      }
      else if(this.timeLeft==0){
        this.showResendFlag=true;
        this.isTrue = false;
        this.istrue =  false;
        clearInterval(this.interval);
      }
       else {
        this.timeLeft = 60;
      }
    },1000)
  }
  submit(value:any){
    console.log("this is value of otp",value);
    this.otpForm.value.otp = Number(value);
  }
  wrongemail(){
    this.otpTime = false;
    this.emailTime = true;
  }
   myFunction(){
    var x:any = document.getElementById("inputPassword");
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  }
  closefrg(): void{
    console.log("this is");
    this.emailTime=true;
    this.otpTime=false;
    this.passTime=false;
    this.clsref?.nativeElement.click();
  }
}
